import React from "react";
import styled from "styled-components";

const Svg = styled.svg`
  display: block;
  height: 30px;
  width: 30px;
`;
const Path = styled.path`
  fill: ${({ theme }) => theme.palette.primary.light};
`;
const Bars = () => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
      <Path d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z" />
    </Svg>
  );
};

export default Bars;
//<!--! Font Awesome Pro 6.3.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
